import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import AcquisitionConfigurationTable from "./View/AcquisitionConfigurationTable";
import { PERMISSIONS } from "../../../PermissionsConstants";

const AcquisitionConfiguration = () => {
  const viewAcquisitionConfig =
    PERMISSIONS.permission_utilities_acquisitionconfiguration_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewAcquisitionConfig) && (
        <AcquisitionConfigurationTable />
      )}
    </>
  );
};

export default AcquisitionConfiguration;
